
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/brandProfileDetail",
      function () {
        return require("private-next-pages/brandProfileDetail.js");
      }
    ]);
  